import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers
} from '@reduxjs/toolkit';
import { settingsReducer } from '../slices/settings-slice';
import { ability, defineRulesFor } from 'app/auth/casl';

export const store = configureStore({
  reducer: {
    settings: settingsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

store.subscribe(() => {
  const permissions = store.getState().settings.permissions;
  ability.update(defineRulesFor(permissions));
});

const rootReducer = combineReducers({
  settings: settingsReducer
});

export const setupStore = (preloadedState?: Partial<RootState>): any => {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  });
};

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
